export const LIST_SUBSCRIPTIONS = '[Subscription Manager] List subscriptions';
export const LIST_SUBSCRIPTIONS_SUCCESS =
  '[Subscription Manager] List subscriptions Success';
export const LIST_SUBSCRIPTIONS_ERROR =
  '[Subscription Manager] List subscriptions Error';
